import React from 'react'
// import { BrowserRouter, Route, Router, Switch } from 'react-router-dom'
import Home from './pages/Home.jsx'

function App () {
	return (
		<Home />
	)
}

export default App
